import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { SettingsNames } from '@/widgets/sidebar'

import { resolveChatMessagingUiEnabled, whenAccessFeaturesReady } from '@/shared/composables/user-features/access-ui-resolvers'

/** Настройки чата доступны только при полном UC (веб-клиент + InstantMessaging). */
export const chatSettingsBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  await whenAccessFeaturesReady()
  if (!resolveChatMessagingUiEnabled()) {
    next({ name: SettingsNames.interface })
    return
  }
  next()
}
